module.exports = __webpack_public_path__ + "img/shenhe@2x.9fcdc680.png";